// extracted by mini-css-extract-plugin
export default {"load":"loader_load__bthiw","opacityAnimation":"loader_opacityAnimation__PauHX","spin":"loader_spin__S-6on"};